import React from 'react';
import styles from './ErrorPage.module.scss';
import { Page } from '../../components/Page';
import { Link } from '@carbon/react';

const ErrorPage = ({ links }) => (
  <Page
    pageClass="error-page"
    mainContentClass="error-page__r2"
    pageTitle="Fehler">
    <div className={styles.container}>
      <h2 className={styles.heading}>Something's gone wrong...</h2>
      <p className={styles.paragraph}>
        Sorry, we can't find the page you are looking for.
        {links && ' Maybe some of these most visited links will help you?'}
      </p>
      {links && (
        <ul className={styles.list}>
          {links.map(({ href, text }, i) => (
            <li key={i}>
              <Link className={styles.link} to={href}>
                {text}
              </Link>
            </li>
          ))}
        </ul>
      )}
      <span className={styles.fourOhFour}>404</span>
    </div>
  </Page>
);

export default ErrorPage;
